import { useCallback, useEffect } from "react";

export default function EscapeListener({ children, enabled = true, onKeyPress = (e)=>{} }) {
    
    const onEscapeListener = useCallback((event) => {
        if(enabled && event?.key && event.key.toLocaleUpperCase() === "ESCAPE") 
            return onKeyPress(event);
    }, [onKeyPress, enabled]);

    useEffect(() => {
        document.addEventListener("keyup", onEscapeListener);
        return () => {
            document.removeEventListener("keyup", onEscapeListener);
        }
    }, [onEscapeListener])

    return children;
}